var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphSocialSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.386 14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BDD9FF",
    cx: 22.445,
    cy: 8.155,
    rx: 8.169,
    ry: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    x: 14.451,
    y: 18.38,
    width: 15.317,
    height: 32.62,
    rx: 3.053
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.501 20.189.014.019a5.088 5.088 0 0 1-1.25 7.092L10.02 37.257a5.088 5.088 0 0 1-7.08-1.249l-.014-.02a5.088 5.088 0 0 1 1.25-7.091l14.245-9.957a5.088 5.088 0 0 1 7.08 1.249z",
    fill: "#BDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 41.614 14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFDBBB",
    cx: 22.445,
    cy: 8.155,
    rx: 8.169,
    ry: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFAB61",
    x: 14.451,
    y: 18.38,
    width: 15.317,
    height: 32.62,
    rx: 3.053
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.501 20.189.014.019a5.088 5.088 0 0 1-1.25 7.092L10.02 37.257a5.088 5.088 0 0 1-7.08-1.249l-.014-.02a5.088 5.088 0 0 1 1.25-7.091l14.245-9.957a5.088 5.088 0 0 1 7.08 1.249z",
    fill: "#FFDBBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphSocialSupport);
export default __webpack_public_path__ + "static/media/icons_graph_social_support.6513fd9826e56d2be8f5a13c6b7de273.svg";
export { ForwardRef as ReactComponent };